import React from "react";
import { ErrataWidget } from "../../../personal-studio-components/studio";
function ErrorPage() {
  const searchParams = new URLSearchParams(window.location.search);
  const error = searchParams.get("error");
  const errata = { errors: [error] };
  return <ErrataWidget errata={errata}></ErrataWidget>;
}

export default ErrorPage;
